import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "./step-library"
import { useRoutingInfo } from "components/carrot-plans/context/RoutingInfoContext"

const ViewName = Steps.CARE_NAVIGATION_DECISION
export default function CareNavigationDecisionStep(): JSX.Element {
  const { routingData } = useRoutingInfo()
  const journeyValue = routingData?.journey

  function isAdoptionOrGC(journeyValue) {
    switch (journeyValue) {
      case "ADOPTION":
      case "GESTATIONAL":
        return true
      default:
        return false
    }
  }

  const nextStepValue = isAdoptionOrGC(journeyValue) ? "NO" : "YES"

  const { setNextStep } = useStateMachine(ViewName, nextStepValue)
  useEffect(() => {
    setNextStep(ViewName, nextStepValue)
  })
  return <></>
}
